import React from "react";
import { createContext, useState, useContext } from "react";
import { AuthContext } from "../../contexts/AuthContext/AuthContext";
import { GetConversationService } from "../../services/Chat/ConversationService"

export const ConversationContext = createContext();

export const ConversationProvider = ({ children }) => {
  const [conversation, setConversation] = useState([]);
    
  const { token } = useContext(AuthContext);

  const GetConversation = async (thread_id) => {
    const dataConversation = await GetConversationService(thread_id, token);
    
    if (!dataConversation["error"]) {
      setConversation(prev => [
        ...prev, 
        ...dataConversation["content"]
      ]);

      return true;
    }

    return false;
  };

  return (
    <ConversationContext.Provider value={{ conversation, setConversation, GetConversation }}>
      {children}
    </ConversationContext.Provider>
  );
};
